export const PKG_NAME = "@hpcc-js/react";
export const PKG_VERSION = "2.53.8";
export const BUILD_VERSION = "2.104.28";
